'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _addImage = require('./modifiers/addImage');

var _addImage2 = _interopRequireDefault(_addImage);

var _Image = require('./Image');

var _Image2 = _interopRequireDefault(_Image);

var _imageStyles = {
  "image": "draftJsEmojiPlugin__image__192TI"
};

var _imageStyles2 = _interopRequireDefault(_imageStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTheme = {
  image: _imageStyles2.default.image
};

exports.default = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var theme = config.theme ? config.theme : defaultTheme;
  var Image = config.imageComponent || _Image2.default;
  if (config.decorator) {
    Image = config.decorator(Image);
  }
  var ThemedImage = function ThemedImage(props) {
    const _contentState$getEnti = props.contentState.getEntity(props.block.getEntityAt(0)).getData();
    const caption = _react2.default.createElement('figcaption', {key: 'caption'}, _contentState$getEnti.caption );
    let icon = '';
    if (_contentState$getEnti.isInstagram && (_contentState$getEnti.caption || '').length) {
        icon = _react2.default.createElement(
            'img',
            {
                src: 'https://jrnl.s3.amazonaws.com/dev/entry_images/10/2020/12/29/instagram-icon_fccb17ca-2e1f-41e4-9467-c5b371787375.png',
                alt: 'icon',
                width: 25,
                height: 25,
                style: { 
                    'marginTop': '.625rem',
                    'marginRight': '10px',
                    'height': '25px'
                }
            }
        );
    } else if (_contentState$getEnti.isFacebook && (_contentState$getEnti.caption || '').length) {
        icon = _react2.default.createElement(
            'img',
            {
                src: 'https://jrnl.s3.amazonaws.com/dev/entry_images/10/2021/01/11/facebook-icon_c59595de-2687-47e3-9861-8549c28c68d4.png',
                alt: 'icon',
                width: 15,
                height: 25,
                style: { 
                    'marginTop': '.625rem',
                    'marginRight': '10px',
                    'height': '25px'
                }
            }
        );
    }
    const captionContainer = _react2.default.createElement(
        'div',
        {
            style: {
                'display': 'flex',
                'flexDirection': 'row',
                'marginTop': '5px'
            }
        },
        [icon, caption]
    )
    const img = _react2.default.createElement(Image, _extends({}, props, { theme: theme }))
    return _react2.default.createElement('div', {}, [img, captionContainer]);
  };
  return {
    blockRendererFn: function blockRendererFn(block, _ref) {
      var getEditorState = _ref.getEditorState;

      if (block.getType() === 'atomic' || block.getType() === 'unstyled') {
        var contentState = getEditorState().getCurrentContent();
        var entity = block.getEntityAt(0);
        if (!entity) return null;
        var type = contentState.getEntity(entity).getType();
        if (type === 'IMAGE' || type === 'image') {
          return {
            component: ThemedImage,
            editable: false,
            props: {
              caption: 'abcd'
            }
          };
        }
        return null;
      }

      return null;
    },
    addImage: _addImage2.default
  };
};

var Image = exports.Image = _Image2.default;